import { Link } from "react-router-dom";
import PageLayout from "@/components/feature/PageLayout";
import Seo from "@/components/feature/Seo";
import { breadcrumbJsonLd } from "@/lib/seo";
import { pageMeta } from "@/lib/pageMeta";
import { services } from "@/mocks/services";

const jsonLd = [
  breadcrumbJsonLd([
    { name: "Home", path: "/" },
    { name: "Services", path: "/services" },
  ]),
];

export default function Services() {
  return (
    <PageLayout
      eyebrow="Our Services"
      title={
        <>
          Private Chauffeur Services
          <br />
          <span className="italic text-foreground-500 font-normal">in Los Angeles</span>
        </>
      }
      intro="From LAX airport transfers to Hollywood nightlife and Malibu coast tours. Every ride is private, door-to-door, and available 24/7 with a licensed professional driver."
    >
      <Seo
        title={pageMeta.services.title}
        description={pageMeta.services.description}
        path={pageMeta.services.path}
        jsonLd={jsonLd}
      />
      <section className="px-4 md:px-6 lg:px-10 pb-14 md:pb-20">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          {services.map((service) => (
            <article
              key={service.id}
              className="flex flex-col sm:flex-row bg-background-50 rounded-2xl border border-background-200/60 overflow-hidden"
            >
              <div className="sm:w-2/5 flex-shrink-0">
                <img
                  src={service.image}
                  alt={`${service.title}, private driver service in Los Angeles`}
                  loading="lazy"
                  className="w-full h-48 sm:h-full object-cover object-top"
                />
              </div>
              <div className="p-5 md:p-6 flex flex-col">
                <span className="text-xs font-medium text-primary-600 tracking-widest uppercase mb-2">
                  {service.subtitle}
                </span>
                <h2 className="font-heading text-lg md:text-xl font-semibold text-foreground-950 mb-2">
                  {service.title}
                </h2>
                <p className="text-foreground-600 text-sm leading-relaxed mb-4 flex-1">
                  {service.description}
                </p>
                <Link
                  to="/#reservation"
                  className="inline-flex items-center gap-2 text-sm font-medium text-foreground-950 underline underline-offset-4 decoration-primary-400 hover:text-primary-600 transition-colors"
                >
                  <span>Get a Free Quote</span>
                  <i className="ri-arrow-right-line" />
                </Link>
              </div>
            </article>
          ))}
        </div>
      </section>
    </PageLayout>
  );
}
